import React, { useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";

const TITLE = "Calculatrice de béton - Estimation de la quantité et du coût du béton";
const DESCRIPTION =
  "Calculatrice de béton - Estimation de la quantité et du coût du béton pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "de béton estimation de la quantité et du coût du béton, calculatrice de béton estimation de la quantité et du coût du béton, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/calculatrice-beton/";

const ConcreteCalculator = () => {
  useEffect(() => {
    window.concreteCalc = {
      isNumber(val) {
        val = val + "";
        if (val.length < 1) return false;
        if (isNaN(val)) {
          return false;
        } else {
          return true;
        }
      },
      showquickobjmsg(C, B, A) {
        const element = document.getElementById(A);
        if (element) {
          if (B) {
            C = "<span style='color: #dc3545; font-weight: 600;'>" + C + "</span>";
          }
          element.innerHTML = C;
        }
      },
      calcslab(A) {
        const th = document.getElementById("slablength")?.value?.trim() || "";
        const SG = document.getElementById("slablengthunit")?.value?.trim() || "";
        const NP = document.getElementById("slabwidth")?.value?.trim() || "";
        const gd = document.getElementById("slabwidthunit")?.value?.trim() || "";
        const IB = document.getElementById("slabthick")?.value?.trim() || "";
        const gE = document.getElementById("slabthickunit")?.value?.trim() || "";
        const KR = document.getElementById("slabquantity")?.value?.trim() || "";

        if (!this.isNumber(th)) {
          this.showquickobjmsg("La longueur doit être un nombre", true, A);
          return;
        } else if (!this.isNumber(NP)) {
          this.showquickobjmsg("La largeur doit être un nombre", true, A);
          return;
        } else if (!this.isNumber(IB)) {
          this.showquickobjmsg("L'épaisseur doit être un nombre", true, A);
          return;
        } else if (!this.isNumber(KR)) {
          this.showquickobjmsg("La quantité doit être un nombre", true, A);
          return;
        }

        let length = parseFloat(th);
        let width = parseFloat(NP);
        let thick = parseFloat(IB);
        const quantity = parseFloat(KR);

        if (length < 0 || width < 0 || thick < 0 || quantity < 0) {
          this.showquickobjmsg("Tous les chiffres doivent être positifs", true, A);
          return;
        }

        if (SG == "foot") length = length * 0.3048;
        else if (SG == "inch") length = length * 0.0254;
        else if (SG == "yard") length = length * 0.9144;
        else if (SG == "centimeter") length = length * 0.01;

        if (gd == "foot") width = width * 0.3048;
        else if (gd == "inch") width = width * 0.0254;
        else if (gd == "yard") width = width * 0.9144;
        else if (gd == "centimeter") width = width * 0.01;

        if (gE == "foot") thick = thick * 0.3048;
        else if (gE == "inch") thick = thick * 0.0254;
        else if (gE == "yard") thick = thick * 0.9144;
        else if (gE == "centimeter") thick = thick * 0.01;

        const ET = length * width * thick * quantity;
        const gA = ET / 0.3048 / 0.3048 / 0.3048;
        const PP = ET / 0.9144 / 0.9144 / 0.9144;
        const bQ = ET * 2130;
        const vH = gA * 133;

        let ko = "<div style='background: linear-gradient(135deg, #d1f4e0 0%, #b8f0d0 100%); padding: 20px; border-radius: 12px; border-right: 4px solid #1a5f3f; margin-top: 15px;'>";
        ko += "<h3 style='color: #1a5f3f; font-weight: 700; margin-bottom: 15px; font-size: 18px;'>Résultats:</h3>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'><strong style='color: #1a5f3f;'>" + gA.toPrecision(3) + "</strong> pieds cubes</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>ou <strong style='color: #1a5f3f;'>" + PP.toPrecision(3) + "</strong> yards cubes</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>ou <strong style='color: #1a5f3f;'>" + ET.toPrecision(3) + "</strong> mètres cubes</p>";
        ko += "<hr style='border-top: 1px solid rgba(26, 95, 63, 0.2); margin: 15px 0;'>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>Si le béton est préfabriqué*, c'est <strong style='color: #1a5f3f;'>" + vH.toPrecision(3) + "</strong> livres</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>ou <strong style='color: #1a5f3f;'>" + bQ.toPrecision(3) + "</strong> kg</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>Si 60 livres par sac, c'est <strong style='color: #1a5f3f;'>" + (vH / 60).toPrecision(3) + "</strong> sacs</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>Si 80 livres par sac, c'est <strong style='color: #1a5f3f;'>" + (vH / 80).toPrecision(3) + "</strong> sacs</p>";
        ko += "</div>";
        this.showquickobjmsg(ko, false, A);
      },
    };
  }, []);

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de béton est un outil utile et précis pour estimer rapidement la quantité de béton nécessaire pour vos projets de construction. Elle vous aide à planifier et budgétiser efficacement.
                </p>
                <p>
                  Entrez les dimensions de votre projet (longueur, largeur, épaisseur) et obtenez un calcul détaillé du volume de béton requis, du poids et du nombre de sacs de ciment nécessaires.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <h4>Dalle de béton</h4>
                    <div className="form-group">
                      <label>Longueur</label>
                      <input id="slablength" type="number" placeholder="Longueur" className="form-control" style={{ width: "75%" }} />
                      <select id="slablengthunit" className="form-control mt-2" style={{ width: "75%" }}>
                        <option value="meter">Mètre</option>
                        <option value="foot">Pied</option>
                        <option value="inch">Pouce</option>
                        <option value="yard">Yard</option>
                        <option value="centimeter">Centimètre</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Largeur</label>
                      <input id="slabwidth" type="number" placeholder="Largeur" className="form-control" style={{ width: "75%" }} />
                      <select id="slabwidthunit" className="form-control mt-2" style={{ width: "75%" }}>
                        <option value="meter">Mètre</option>
                        <option value="foot">Pied</option>
                        <option value="inch">Pouce</option>
                        <option value="yard">Yard</option>
                        <option value="centimeter">Centimètre</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Épaisseur</label>
                      <input id="slabthick" type="number" placeholder="Épaisseur" className="form-control" style={{ width: "75%" }} />
                      <select id="slabthickunit" className="form-control mt-2" style={{ width: "75%" }}>
                        <option value="meter">Mètre</option>
                        <option value="foot">Pied</option>
                        <option value="inch">Pouce</option>
                        <option value="yard">Yard</option>
                        <option value="centimeter">Centimètre</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Quantité de dalles</label>
                      <input id="slabquantity" type="number" placeholder="Quantité" className="form-control" style={{ width: "75%" }} defaultValue={1} />
                    </div>
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "18px" }}
                      onClick={() => window.concreteCalc.calcslab("result")}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div id="result"></div>
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice de béton</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Cet outil est indispensable pour tout professionnel du bâtiment.
                        Instructions d'utilisation :
                      </p>
                      <ol>
                        <li>Entrez les dimensions : longueur × largeur × hauteur.</li>
                        <li>Choisissez le type de mélange (résistant ou léger).</li>
                        <li>Obtenez le volume en m³ et l'estimation des matériaux
                            (ciment, sable, gravier, eau).</li>
                      </ol>
                      <p>
                        Exemples : fondation 200 m² × 0,3 m = 60 m³ ;
                        dalle 120 m² × 0,15 m = 18 m³ ;
                        10 colonnes Ø 0,5 m hauteur 3 m.
                      </p>
                      <p>
                        Avantages : précision des estimations, calcul des coûts,
                        personnalisation selon le projet, réduction des erreurs.
                        Conseils : vérifiez les mesures avec précision,
                        choisissez le bon type de béton et ajoutez une marge de sécurité.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
};

export default ConcreteCalculator;
